import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { z } from 'zod';

import {
  GetCompRecommendationError,
  GetCompRecommendationVariables,
  fetchGetCompRecommendation,
} from '../toolkitComponents.js';
import { queryKeyFn, useToolkitContext } from '../toolkitContext.js';
import { Registry } from './registry.js';

type Response = z.infer<typeof schema>;
const { schema } = Registry.getCompRecommendation;

export function useGetCompRecommendation(
  variables: GetCompRecommendationVariables,
  opts?: UseQueryOptions<Response, GetCompRecommendationError>,
): UseQueryResult<Response> {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<Response, GetCompRecommendationError>(
    queryKeyFn({
      path: '/api/v2/orders/{orderID}/compRecommendation',
      operationId: 'getCompRecommendation',
      variables,
    }),
    async () => {
      const res = await fetchGetCompRecommendation({ ...fetcherOptions, ...variables });
      return schema.parse(res);
    },
    opts,
  );
}
